import i18next from "i18next";
import cs from "./cs.json";

i18next.init({
  lng: "cs",
  debug: process.env.NODE_ENV !== "production",

  resources: {
    cs,
  },
});
